// @ts-nocheck
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {BaseTooltip, toast} from "@/components";
import copyBtn from "../../../assets/images/modal-icons/copy-btn.svg";
import imgZelle from "../../../assets/images/modal-icons/zelle.svg";
import {useBalanceStore} from "../../../store/useBalance.store";
import {useUserSupport} from "../../../store/useUserSupport.store";

const ZELLE_EMAIL = "zelle@coronando.com";

const ZelleOptions = ({prev}) => {
  const handleBankAccountModal = useBalanceStore(state => state.handleBankAccountModal);
  const {t} = useTranslation();
  const handleSupportModal = useUserSupport(state => state.handleSupportModal);

  const copyToClipboard = async text => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success(t("depositInstructionsCopied"));
    } catch (error) {
      toast.error(t("depositInstructionsError"), error);
    }
  };

  const handleSupportClick = () => {
    handleSupportModal();
    handleBankAccountModal();
    prev();
  };

  return (
    <div className="flex flex-col gap-6 py-2">
      <img
        src={imgZelle}
        alt="Zelle"
        className="w-[117px] h-[49px]"
      />

      <p className="text-[var(--color-text-secondary)] text-sm leading-relaxed">
        {t("depositInstructionsZelleMessage")}
      </p>

      <div className="flex items-center gap-3">
        <span className="text-[var(--color-text)] text-sm font-semibold">
          {t("depositInstructionsZelleEmail")}:
        </span>
        <button
          type="button"
          className="flex items-center gap-2 px-4 py-2 rounded-xl text-sm text-white bg-[var(--color-surface-hover)] border border-[var(--color-border)] hover:border-[var(--color-lottery)] transition-colors cursor-pointer"
          onClick={() => copyToClipboard(ZELLE_EMAIL)}
        >
          <span>{ZELLE_EMAIL}</span>
          <BaseTooltip title={t("depositInstructionsCopy")}>
            <img
              src={copyBtn}
              alt="copy"
              className="w-5 h-5"
            />
          </BaseTooltip>
        </button>
      </div>

      <div className="flex justify-center gap-4 mt-2">
        <button
          type="button"
          className="px-6 py-2.5 rounded-full text-sm font-semibold text-white bg-[var(--color-lottery)] hover:bg-[var(--color-lottery-soft)] border-0 cursor-pointer transition-colors"
          onClick={handleSupportClick}
        >
          {t("depositInstructionsSupport")}
        </button>
        <button
          type="button"
          className="px-6 py-2.5 rounded-full text-sm font-semibold text-[var(--color-lottery)] border border-[var(--color-lottery)] bg-transparent hover:bg-[var(--color-lottery)] hover:text-white cursor-pointer transition-colors"
          onClick={prev}
        >
          {t("depositInstructionsBack")}
        </button>
      </div>
    </div>
  );
};

ZelleOptions.propTypes = {
  prev: PropTypes.func,
};

export default ZelleOptions;
